export default {
  globalParams: {},
  acquisitionInfo: {},
  participateInfo: {},
  payInfo: {},
  selectedCard: {},
  membership: {},
  extraInfoList: [],
  brandName: 'DiDi Pack',
  unSubscribeInfoData: {},
  paySuccessInfo: {}, // 支付成功信息
}
